module.exports = __webpack_public_path__ + "img/pay-info.04ad5ab4.svg";